<template>
  <div class="detail-tech" v-for="item in teaDesc" :key="item.index">
    <div class="tech">
      <img v-lazy="item.teImg" alt="" />
      <h5>{{ item.teName }}</h5>
    </div>
    <div class="tech-desc">
      {{ item.teDesc }}
    </div>
  </div>
</template>

<script>
import { ref, watch } from "vue";
export default {
  name: "VideoOutline",
  props: {
    videoData: {
      type: Array,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const teaDesc = ref([]);

    watch(
      () => props.videoData,
      (newData, OldData) => {
        try {
          teaDesc.value = newData[0]?.teacher.map((item) => {
            return {
              teDesc: item.teDesc,
              teID: item.teID,
              teImg: "/web/" + item.teImg,
              teName: item.teName,
            };
          });
        } catch (error) {
          console.log(error);
        }
      }
    );
    return { teaDesc };
  },
};
</script>

<style lang="less" scoped>
.detail-tech {
  border-bottom: 1px solid #f5f5f5;
  .tech {
    display: flex;
    align-items: center;
    height: 100px;

    img {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      margin-left: 20px;
      background: #c0c4cc;
    }
    h5 {
      margin-left: 15px;
    }
  }
  .tech-desc {
    margin-bottom: 15px;
    margin-left: 20px;
    margin-right: 20px;
    line-height: 25px;
    color: #999;
  }
}
</style>
